import { ClearCacheDataScreenNavigationProps } from "./types"
import React from "react"
import ClearCacheData from "./clear-cache-data-screen"
import { PageRoot } from "~screens/page-root"


// 数据清理
const ClearCacheDataScreen: React.FC<ClearCacheDataScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <ClearCacheData route={route}/>
    </PageRoot>
  )
}

export default ClearCacheDataScreen
